import { render, staticRenderFns } from "./TopSellingProductSummary.vue?vue&type=template&id=63963b50&"
import script from "./TopSellingProductSummary.vue?vue&type=script&lang=js&"
export * from "./TopSellingProductSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports